export default __webpack_public_path__ + "static/media/sidebar-5.23ad1376.jpg";